<div
  class="dialog-content"
  [ngClass]="[dialogId(), screenModeClass, shouldBeRounded ? 'rounded-md' : '']"
  [attr.role]="'dialog'"
  [attr.aria-label]="ariaLabel"
  [attr.aria-modal]="true"
  (keydown.escape)="onEscape()">
  <div [id]="dialogId()" class="dialog-body" (click)="onDialogClicked($event)">
    <ng-container #viewChild></ng-container>
  </div>
</div>

<div class="dialog-overlay" (click)="onOverlayClicked($event)"></div>
